

import React, { useEffect } from 'react';
import moment from 'moment';
import { Spin, Pagination, Button } from 'antd';
import { debounce } from 'lodash';

import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
// import background from "./public/images/contact-banner.png";

const setSearchFilter = debounce((value, props) => {
  const { setPage, setSearchFilter, getNews } = props;
  setPage(1);
  setSearchFilter(value);
  getNews();
}, 300);


const News = (props) => {
  const { setPage, getBusinessNews, setViewMoreFlag, view_more, getNews, loading, businessNews, pagination, news } = props;
  const { data, total } = news || [];
  const worldNews = data && data.length ? data.filter(({ type }) => type === 'world') : [];
  const firstRowNews = worldNews && worldNews.length ? worldNews.filter((news, index) => index <= 1) : [];
  const remainingRowNews = worldNews && worldNews.length ? worldNews.filter((news, index) => index > 1) : [];
  useEffect(() => {
    getBusinessNews();
    getNews();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps 
  return (
    <div>
      <section className="news-banner">
        <div className="container-fluid p-0">
          <OwlCarousel className="owl-carousel owl-theme news-banner-slider" loop={true} margin={0} dots={true} responsive={{ 0: { items: 1 } }} nav={true}>
            <div className="item item-1">
              <div className="container">
                <div className="banner-text">
                  <p className="tag">Latest News</p>
                  <p className="date">Published on: 23 Mar 2020</p>
                  <h1 className="title">Advanced event management and listing system.</h1>
                  <p className="text">The iCause event manager makes planning your event easier – manage registration, communications, merchandise and donations in one simple platform.</p>
                  <ul className="socials-list">
                    <li><a href="/homepage" title=""><i className="fa fa-pinterest-p"></i></a></li>
                    <li><a href="/homepage" title=""><i className="fa fa-twitter"></i></a></li>
                    <li><a href="/homepage" title=""><i className="fa fa-facebook"></i></a></li></ul>
                </div>
              </div>
            </div>
            <div className="item item-1">
              <div className="container">
                <div className="banner-text">
                  <p className="tag">Latest News</p>
                  <p className="date">Published on: 23 Mar 2020</p>
                  <h1 className="title">Advanced event management and listing system.</h1>
                  <p className="text">The iCause event manager makes planning your event easier – manage registration, communications, merchandise and donations in one simple platform.</p>
                  <ul className="socials-list">
                    <li><a href="/homepage" title=""><i className="fa fa-pinterest-p"></i></a></li>
                    <li><a href="/homepage" title=""><i className="fa fa-twitter"></i></a></li>
                    <li><a href="/homepage" title=""><i className="fa fa-facebook"></i></a></li></ul>
                </div>
              </div>
            </div>
          </OwlCarousel>
        </div>
      </section>

      <section className="news-media news-sec-2">
        <div className="container">
          <div className="row  ">
            <div className="col-lg-7 col-md-6 col-sm-12 m-auto">
              <div className="text-wrap">
                <h1 className="text-center">News & Media</h1>
                <p className="text-center">Do you have questions? Our FAQs contain advice for setting up accounts and campaigns, donating and our most common questions. Search the FAQs below.</p>
                <div className="search-box">
                  <input onChange={({ target }) => setSearchFilter(target.value, props)} type="search" className="form-control  " name="" placeholder="Enter News. Ex World, Business etc." />
                  <i className="fa fa-search search-icon"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Spin spinning={loading}>
        <section className="trending-causes second-trending news-sec-3">
          <div className="container">
            <div className="row justify-content-center">
              {
                firstRowNews && firstRowNews.length ?
                  firstRowNews.map(({ image, created_at, title, short, id }, index) => {
                    let newsCover = '/images/news-card-2.jpg';
                    const reducedShort = short ? (short.length >= 104 ? `${short.substring(0, 104)}...` : short) : 'N/A';
                    if (image) {
                      newsCover = `${process.env.REACT_APP_BACKEND_BASE_URL}/${image}`;
                    }
                    return (
                      <div key={index} className="col-lg-4 col-md-6 col-sm-6 col-12">
                        {index === 0 ? <h4 className="text-black">World News</h4> : <h4 className="text-white">World News</h4>}
                        <div className="card custom-news-card mt-lg-2 ml-lg-0">
                          <a href={`/news-detail/${id}`}>
                            <div className="img">
                              <img style={{ height: '270px' }} src={newsCover} className="img-fluid" alt="" />
                            </div>
                            <div className="text-card d-flex align-items-center justify-content-between">
                              <span><img src="/images/customer-icon-img.png" className="img-fluid img-width" alt="" /></span>
                              <span>Published on: {moment(created_at).format('LL')}</span>
                            </div>
                            <h1>{title}</h1>
                            <p dangerouslySetInnerHTML={{ __html: reducedShort || '' }}></p>
                            <a href="/homepage" className="read-more"><i className="fa fa-arrow-right"></i></a>
                          </a>
                        </div>
                      </div>
                    );
                  }) : ''
              }
              <div style={{ height: '590px', overflowY: 'auto' }} className="col-lg-4 col-md-6 col-sm-12">
                {/* <h4 class="font-weight-bold mb-0">Business News</h4> */}
                {
                  businessNews && businessNews.length ?
                    businessNews.map(({ image, created_at, id, title, short }, index) => {
                      let newsCover = '/images/our-mission-2.PNG';
                      const reducedShort = short ? (short.length >= 104 ? `${short.substring(0, 104)}...` : short) : 'N/A';
                      if (image) {
                        newsCover = `${process.env.REACT_APP_BACKEND_BASE_URL}/${image}`;
                      }
                      return (
                        <div key={index} className="media business-media mt-2">
                          <img style={{ height: '100px' }} src={newsCover} alt="" />
                          <a style={{ color: 'black' }} href={`/news-detail/${id}`}>
                            <div className="media-body">
                              <h6 className="font-weight-bold">{title}</h6>
                              <p>{reducedShort}</p>
                              <small className="text-right d-block ml-auto my-1">PUBLISHED ON: {moment(created_at).format('LL')}</small>
                            </div>
                          </a>

                        </div>
                      );
                    })
                    : ''
                }
                <div style={{ marginTop: 10 }} className="text-center">
                  <Button onClick={() => {
                    setViewMoreFlag(!view_more);
                    getBusinessNews();
                  }} type='primary' size='small'>
                    {view_more ? 'VIEW LESS' : 'VIEW MORE'}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="trending-causes second-trending news-sec-4">
          <div className="container">
            <div className="row justify-content-center">
              {
                remainingRowNews && remainingRowNews.length ?
                  remainingRowNews.map(({ image, id, created_at, title, short }, index) => {
                    let newsCover = '/images/news-card-2.jpg';
                    const reducedShort = short ? (short.length >= 104 ? `${short.substring(0, 104)}...` : short) : 'N/A';
                    if (image) {
                      newsCover = `${process.env.REACT_APP_BACKEND_BASE_URL}/${image}`;
                    }
                    return (
                      <div key={index} className="col-lg-4 col-md-6 col-sm-12">
                        <div className="card custom-news-card mt-lg-2 ml-lg-0">
                          <a href={`/news-detail/${id}`}>
                            <div className="img">
                              <img style={{ height: '270px' }} src={newsCover} className="img-fluid" alt="" />
                            </div>
                            <div className="text-card d-flex align-items-center justify-content-between">
                              <span><img src="/images/customer-icon-img.png" className="img-fluid img-width" alt="" /></span>
                              <span>Published on: {moment(created_at).format('LL')}</span>
                            </div>
                            <h1>{title}</h1>
                            <p>{reducedShort}</p>
                            <a href="/homepage" className="read-more"><i className="fa fa-arrow-right"></i></a>
                          </a>
                        </div>
                      </div>
                    );
                  }) : ''
              }
            </div>
          </div>
        </section>
      </Spin>
      <div style={{ textAlign: 'center', marginBottom: 50 }} className="container">
        <Pagination
          onChange={(page) => {
            setPage(page);
            getNews();
          }}
          size='small'
          current={pagination.pageNumber}
          defaultPageSize={pagination.pageSize}
          total={total}
          pageSizeOptions={[9]}
          showSizeChange={false}
          showTotal={(total, range) => `${range[0]}-${range[1]} of ${total} items`}
        />
      </div>
    </div>
  );
};

export default News;
